(() => {
	const load = LS.util.load,
		filters = {
			guard: () => {
				if (LS.user.active()) {
					return true;
				}

				location.href = '/auth/login?return=' + location.pathname;

				return false;
			},
			index: segment => ! segment || segment === 'filter' || /^p\d+$/.test(segment),
			directory: segment => LS.filters.isDirectory(segment),
			property: segment => LS.filters.isProperty(segment),
			segment: segment => ! filters.entry(segment),
			entry: segment => /^\d{6,}$/.test(segment)
		};

	$.routes.config('before', conf => {
		if ($$('error').length) {
			conf.path = 'error';
		}
	});

	$.routes.addFilter(filters);

	$.routes.map({
		'$any:fire:once': () => {
			LS.common.init();
		},

		'$root:preload:once': () => {
			load('home');
		},

		'$property': {
			'$any': {
				'$segment': {
					'$any': {
						':preload': 'properties:preload',
						':load': 'properties',
						':unload': 'properties:unload'
					}
				}
			},
			'$slug': {
				'$entry:preload:once': () => {
					load('property');
				}
			}
		},

		'$directory': {
			'$any': {
				'$segment': {
					'$index:preload:once': () => {
						load('directory');
					}
				}
			},
			'$slug': {
				'$entry:preload:once': () => {
					load('profile');
				}
			}
		},

		'collections': {
			'$any:preload:once': () => {
				load('collection');
			}
		},

		'blog': {
			'$any:preload:once': () => {
				load('blog');
			}
		},

		'support': {
			'$any:preload:once': () => {
				load('support');
			}
		},

		'advertise:preload:once': () => {
			load('advertise');
		},

		'careers': {
			'$any:preload:once': () => {
				load('careers', null, false);
			}
		},

		'contact:preload:once': () => {
			load('contact');
		},

		'feed': {
			'$any:preload:once': () => {
				load('feed');
			}
		},

		'about': {
			'$any:preload:once': () => {
				load('about', null, false);
			}
		},

		'account': {
			'$any:preload:once': () => {
				load('account');
			}
		},

		'news': {
			'$/^(?!(p\\d+)).*$/': {
				':load': 'article',
				':unload': 'article:unload'
			}
		},

		'corp': {
			'$any': {
				':load': 'article',
				':unload': 'article:unload'
			}
		},

		'price:preload:once': () => {
			load('price');
		},

		'loan-calculator:preload:once': () => {
			load('loan');
		},

		'consent': {
			'$any:preload:once': () => {
				load('consent', null, true, false);
			}
		},

		'sitemap': {
			'$any:preload:once': () => {
				load('sitemap', null, false);
			}
		},

		'auth': {
			'login': 'auth:login',
			'logout': 'auth:logout',
			'register': 'auth:register',
			'forgot': 'auth:forgot',
			'reset': {
				'$token:preload:once': () => {
					load('auth-invite', null, true, false);
				}
			}
		},

		'$any:once:fire': () => {
			LS.common.setup();
		}
	});
})();